export default {
    en: {},
    fr: {
        suffixe1er: 'er'
    }
};
